import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Footer from "../../common/Footer/Footer";
import BlogDetail from "../../components/Blog/BlogDetail";
import Header from '../../common/Header/Header';
import SEO from "../../components/SEO/SEO";

const BlogDetailPage = () => {
  const { id } = useParams();
  const currentBlog = useSelector((state) => state.blogs.currentBlog);

  const seoTitle = currentBlog?.metaTitle || currentBlog?.title;
  const seoDescription = currentBlog?.metaDescription || currentBlog?.description;
  const canonical = currentBlog?.canonicalUrl || `https://mindtherapycounselling.com/blog/${id}`;

  return (
    <div>
      <SEO
        title={seoTitle}
        description={seoDescription}
        canonical={canonical}
        ogType="article"
      />
      <Header />
      <BlogDetail />
      <Footer />
    </div>
  );
};

export default BlogDetailPage;
